import { configurationForToken } from "../CommonConstants";
import apiClient from "./apiClient";

const addAlert = (alert, vehicleId, token) => {
  const config = configurationForToken(token);
  return apiClient.post(`/admin/alert/vehicle/${vehicleId}/create`, alert, config);
};

const updateAlert = (alert, alertId, token) => {
  const config = configurationForToken(token);
  return apiClient.put(`/admin/alert/${alertId}`, alert, config);
};

const deleteAlert = (alertId, token) => {
  const config = configurationForToken(token);
  return apiClient.delete(`/admin/alert/${alertId}`, config);
};

const allAlerts = (token) => {
  const config = configurationForToken(token);
  return apiClient.get("/admin/alert/all", config);
};

const allVehicleAlerts = (vehicleId, token) => {
  const config = configurationForToken(token);
  return apiClient.get(`/admin/alert/vehicle/${vehicleId}/all`, config);
};

export default {
  addAlert,
  updateAlert,
  deleteAlert,
  allAlerts,
  allVehicleAlerts
};



// WEBPACK FOOTER //
// ./src/Services/AlertService.js